"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DEVICE_ID_LENGTH_TYPE = void 0;
var MAX_DEVICE_ID_LENGTH_TYPE;
(function (MAX_DEVICE_ID_LENGTH_TYPE) {
    MAX_DEVICE_ID_LENGTH_TYPE[MAX_DEVICE_ID_LENGTH_TYPE["MAX_DEVICE_ID_LENGTH"] = 512] = "MAX_DEVICE_ID_LENGTH";
})(MAX_DEVICE_ID_LENGTH_TYPE || (exports.MAX_DEVICE_ID_LENGTH_TYPE = MAX_DEVICE_ID_LENGTH_TYPE = {}));
